import clsx from 'clsx'

import { Hotel } from 'shared/api/tours/search'

import { SearchResultCard } from './components/search-result-card'
import s from './styles.module.scss'

interface Props {
  data: Hotel[]
}

export const SearchResultList = ({ data }: Props) => {
  return (
    <div className={clsx(s.searchResultList, 'container')}>
      {data?.map((item) => (
        <SearchResultCard
          item={item}
          key={item?.hotel_id}
        />
      ))}
    </div>
  )
}
